const CAMEL_CASE_MATCH = /([A-Z])/g;

/**
 * Converts a camelCase string to an underscore_string
 * @param {string} key String to convert
 */
export const camelToSnake = (key) =>
    key.replace(CAMEL_CASE_MATCH, (chars) => `_${chars.toLowerCase()}`);
